<div class="campaignstatus clearfix" style="padding-top: 0;">
  <div class="ui-g ui-fluid">

    <div class="ui-g-9">
      <div class="status-left">
        {{ description }}
      </div>
    </div>

    <div class="ui-g-3">
      <div class="status-right">
        {{ 'campaign.campaignStatus' | translate}}: <span class="statusC">{{ status }}</span>
      </div>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/status/campaign-status.html